// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.width95 {
  width: 95%;
  margin: 2.5rem 0;
  padding: 5rem 0;
}

.cdb .main-heading {
  font-size: 16px;
  text-align: center;
  text-transform: capitalize;
  font-weight: 600;
}

.cdb .facts-figures {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 7px 41px;
  background: white;
  border-radius: 10px;
  margin-bottom: 20px;
}

.cdb .facts-figures .section {
  /* flex: 1; */
  width: 20%;
  display: flex;
  justify-content: center;
  /* align-items: center; */
  flex-direction: column;
  /* margin: auto; */
}

.cdb .facts-figures .section h4 {
  font-size: 14px;
  font-weight: 600;
  text-transform: capitalize;
  color: #778899 !important;
  /* text-align: center; */
}

.cdb .facts-figures .section h3 {
  font-size: 32px;
  font-weight: 600;
  text-transform: capitalize;
  color: #1e2022 !important;
  margin-bottom: 0;
  /* text-align: center; */
}

.cdb .tabs {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 7px 41px;
  background: white;
  border-radius: 10px;
}

.cdb .tabs .div {
  width: 160px;
  height: 60px;
  background: #fff;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.cdb .tabs .div p {
  font-size: 16px;
  color: #000;
  margin: 0;
  text-transform: capitalize;
}

.cdb .tabs .active-div {
  width: 160px;
  height: 60px;
  background: #000720;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.cdb .tabs .active-div p {
  font-size: 16px;
  color: #fff;
  margin: 0;
  text-transform: capitalize;
}

.cdb .select-div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 12px 0;
}

.cdb .select-div .ant-select-selector {
  height: 56px;
  width: 168px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.cdb .select-div h2 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  text-transform: capitalize;
}

.cdb .table-div .ant-table {
  border-radius: 10px;
}

.cdb .table-div .ant-table-thead > tr > th {
  color: #778899;
  font-size: 20px;
  font-weight: 600;
  text-transform: capitalize;
  border-radius: 10px;
  /* overflow: hidden !important; */
}

.cdb .table-div .ant-table-thead > tr > th:nth-child(2) {
  text-align: center;
}

.cdb .table-div .ant-table-thead > tr > th:nth-child(3) {
  text-align: center;
}

.cdb .indicators {
  font-size: 14px;
  font-weight: 600;
  text-transform: capitalize;
  margin: 0;
}

.cdb .your-stats {
  font-size: 24px;
  font-weight: 600;
  text-align: center;
  margin: 0;
}

.cdb .benchmark {
  font-size: 24px;
  font-weight: 600;
  text-align: center;
  margin: 0;
}

.cdb .segmentation-content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 21px 0;
  background: #fff;
  border-radius: 10px;
}

.cdb .segmentation-content .flex {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
}

.cdb .segmentation-content .left-figure {
  width: 285px;
  height: 85px;
  border-radius: 10px;
  filter: drop-shadow(2px 2px 8px #eaeaea);
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.cdb .segmentation-content .left-figure p {
  font-size: 14px;
  font-weight: 600;
  color: #778899;
  text-transform: capitalize;
  margin: 0;
}

.cdb .segmentation-content .left-figure h3 {
  font-size: 32px;
  font-weight: 600;
  color: #1e2022 !important;
  text-transform: capitalize;
  margin: 0;
  line-height: 40px;
}

.cdb .segmentation-content .image {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 355px;
}

.cdb .segmentation-content .image img {
  width: 100%;
}

.cdb .segmentation-content .right-figure {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 14px;
}

.cdb .segmentation-content .right-figure .figure {
  width: 285px;
  height: 70px;
  border-radius: 10px;
  filter: drop-shadow(2px 2px 8px #eaeaea);
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.cdb .segmentation-content .right-figure .figure p {
  font-size: 14px;
  font-weight: 600;
  color: #778899;
  text-transform: capitalize;
  margin: 0;
}

.cdb .segmentation-content .right-figure .figure h3 {
  font-size: 32px;
  font-weight: 600;
  color: #1e2022 !important;
  text-transform: capitalize;
  margin: 0;
  line-height: 40px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/pages/Cdb.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;EACzB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,0BAA0B;EAC1B,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,0BAA0B;EAC1B,SAAS;EACT,iBAAiB;AACnB","sourcesContent":[".container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-direction: column;\r\n}\r\n\r\n.width95 {\r\n  width: 95%;\r\n  margin: 2.5rem 0;\r\n  padding: 5rem 0;\r\n}\r\n\r\n.cdb .main-heading {\r\n  font-size: 16px;\r\n  text-align: center;\r\n  text-transform: capitalize;\r\n  font-weight: 600;\r\n}\r\n\r\n.cdb .facts-figures {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 7px 41px;\r\n  background: white;\r\n  border-radius: 10px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.cdb .facts-figures .section {\r\n  /* flex: 1; */\r\n  width: 20%;\r\n  display: flex;\r\n  justify-content: center;\r\n  /* align-items: center; */\r\n  flex-direction: column;\r\n  /* margin: auto; */\r\n}\r\n\r\n.cdb .facts-figures .section h4 {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  text-transform: capitalize;\r\n  color: #778899 !important;\r\n  /* text-align: center; */\r\n}\r\n\r\n.cdb .facts-figures .section h3 {\r\n  font-size: 32px;\r\n  font-weight: 600;\r\n  text-transform: capitalize;\r\n  color: #1e2022 !important;\r\n  margin-bottom: 0;\r\n  /* text-align: center; */\r\n}\r\n\r\n.cdb .tabs {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 7px 41px;\r\n  background: white;\r\n  border-radius: 10px;\r\n}\r\n\r\n.cdb .tabs .div {\r\n  width: 160px;\r\n  height: 60px;\r\n  background: #fff;\r\n  border-radius: 10px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  cursor: pointer;\r\n}\r\n\r\n.cdb .tabs .div p {\r\n  font-size: 16px;\r\n  color: #000;\r\n  margin: 0;\r\n  text-transform: capitalize;\r\n}\r\n\r\n.cdb .tabs .active-div {\r\n  width: 160px;\r\n  height: 60px;\r\n  background: #000720;\r\n  border-radius: 10px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  cursor: pointer;\r\n}\r\n\r\n.cdb .tabs .active-div p {\r\n  font-size: 16px;\r\n  color: #fff;\r\n  margin: 0;\r\n  text-transform: capitalize;\r\n}\r\n\r\n.cdb .select-div {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin: 12px 0;\r\n}\r\n\r\n.cdb .select-div .ant-select-selector {\r\n  height: 56px;\r\n  width: 168px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.cdb .select-div h2 {\r\n  margin: 0;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  text-transform: capitalize;\r\n}\r\n\r\n.cdb .table-div .ant-table {\r\n  border-radius: 10px;\r\n}\r\n\r\n.cdb .table-div .ant-table-thead > tr > th {\r\n  color: #778899;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  text-transform: capitalize;\r\n  border-radius: 10px;\r\n  /* overflow: hidden !important; */\r\n}\r\n\r\n.cdb .table-div .ant-table-thead > tr > th:nth-child(2) {\r\n  text-align: center;\r\n}\r\n\r\n.cdb .table-div .ant-table-thead > tr > th:nth-child(3) {\r\n  text-align: center;\r\n}\r\n\r\n.cdb .indicators {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  text-transform: capitalize;\r\n  margin: 0;\r\n}\r\n\r\n.cdb .your-stats {\r\n  font-size: 24px;\r\n  font-weight: 600;\r\n  text-align: center;\r\n  margin: 0;\r\n}\r\n\r\n.cdb .benchmark {\r\n  font-size: 24px;\r\n  font-weight: 600;\r\n  text-align: center;\r\n  margin: 0;\r\n}\r\n\r\n.cdb .segmentation-content {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-direction: column;\r\n  padding: 21px 0;\r\n  background: #fff;\r\n  border-radius: 10px;\r\n}\r\n\r\n.cdb .segmentation-content .flex {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 24px;\r\n}\r\n\r\n.cdb .segmentation-content .left-figure {\r\n  width: 285px;\r\n  height: 85px;\r\n  border-radius: 10px;\r\n  filter: drop-shadow(2px 2px 8px #eaeaea);\r\n  background: #fff;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-direction: column;\r\n}\r\n\r\n.cdb .segmentation-content .left-figure p {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: #778899;\r\n  text-transform: capitalize;\r\n  margin: 0;\r\n}\r\n\r\n.cdb .segmentation-content .left-figure h3 {\r\n  font-size: 32px;\r\n  font-weight: 600;\r\n  color: #1e2022 !important;\r\n  text-transform: capitalize;\r\n  margin: 0;\r\n  line-height: 40px;\r\n}\r\n\r\n.cdb .segmentation-content .image {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 355px;\r\n}\r\n\r\n.cdb .segmentation-content .image img {\r\n  width: 100%;\r\n}\r\n\r\n.cdb .segmentation-content .right-figure {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-direction: column;\r\n  gap: 14px;\r\n}\r\n\r\n.cdb .segmentation-content .right-figure .figure {\r\n  width: 285px;\r\n  height: 70px;\r\n  border-radius: 10px;\r\n  filter: drop-shadow(2px 2px 8px #eaeaea);\r\n  background: #fff;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-direction: column;\r\n}\r\n\r\n.cdb .segmentation-content .right-figure .figure p {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: #778899;\r\n  text-transform: capitalize;\r\n  margin: 0;\r\n}\r\n\r\n.cdb .segmentation-content .right-figure .figure h3 {\r\n  font-size: 32px;\r\n  font-weight: 600;\r\n  color: #1e2022 !important;\r\n  text-transform: capitalize;\r\n  margin: 0;\r\n  line-height: 40px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
